import React, { useEffect, useState } from "react";

// Target: July 11, 2026 at 1:30 PM Eastern Time (Pompano Beach is ET).
// Using ISO with -04:00 (EDT in July).
const TARGET = new Date("2026-07-12T13:30:00-04:00");

const pad = (n) => String(n).padStart(2, "0");

const useCountdown = () => {
    const [now, setNow] = useState(Date.now());
    useEffect(() => {
        const id = setInterval(() => setNow(Date.now()), 1000);
        return () => clearInterval(id);
    }, []);

    const diff = Math.max(0, TARGET.getTime() - now);
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((diff / (1000 * 60)) % 60);
    const seconds = Math.floor((diff / 1000) % 60);
    return { days, hours, minutes, seconds, done: diff === 0 };
};

const Block = ({ value, label, testid }) => (
    <div
        data-testid={testid}
        className="bg-primary text-primary-foreground border-thick rounded-2xl shadow-pop-sm px-4 py-5 sm:px-6 sm:py-7 min-w-[88px] sm:min-w-[120px] text-center"
    >
        <div className="font-heading text-4xl sm:text-6xl font-bold leading-none tabular-nums">
            {pad(value)}
        </div>
        <div className="font-heading text-xs sm:text-sm uppercase tracking-widest mt-2 opacity-90">
            {label}
        </div>
    </div>
);

export const Countdown = () => {
    const { days, hours, minutes, seconds } = useCountdown();
    return (
        <section
            id="countdown"
            data-testid="countdown-section"
            className="relative py-20 sm:py-28 polka"
        >
            <div className="max-w-5xl mx-auto px-6 text-center">
                <span
                    data-testid="countdown-badge"
                    className="inline-block font-heading uppercase tracking-widest text-xs sm:text-sm bg-secondary text-secondary-foreground border-thick rounded-full px-5 py-2 shadow-pop-sm"
                >
                    Faltam pouquinhos dias
                </span>
                <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold mt-6">
                    Contagem regressiva pra festa
                </h2>
                <p className="mt-4 text-base sm:text-lg text-muted-foreground max-w-xl mx-auto">
                    Não chegue atrasado! O Mickey está nos esperando para um dia
                    cheio de brincadeiras.
                </p>

                <div className="mt-12 flex flex-wrap items-center justify-center gap-4 sm:gap-6">
                    <Block value={days} label="Dias" testid="countdown-days" />
                    <Block value={hours} label="Horas" testid="countdown-hours" />
                    <Block value={minutes} label="Minutos" testid="countdown-minutes" />
                    <Block value={seconds} label="Segundos" testid="countdown-seconds" />
                </div>
            </div>
        </section>
    );
};

export default Countdown;
